'use strict';

var _ = require('lodash'),
    dialog = require('../dialog'),
    TPromise = require('promise'),
    util = require('../util');

var newLine = '\n';
var storeTemplate = function (store, selectedStoreId, selectedStoreText) {
    return [
        '<li class="store-tile ' + store.storeId + (store.storeId === selectedStoreId ? ' selected' : '') + '">',
        '    <p class="store-name">' + store.displayName + '</p>',
        '    <p class="store-address">',
        '        ' + store.address1 + '<br/>',
        '        ' + store.city + ', ' + store.stateCode + ' ' + store.postalCode,
        '    </p>',
        '    <p class="store-status" data-status="' + store.statusclass + '">' + store.status + '</p>',
        '    <button class="select-store-button button-fancy-large btn-outline-dark" data-store-id="' + store.storeId + '"' + '>',
        '        ' + (store.storeId === selectedStoreId ? selectedStoreText : Resources.SELECT_STORE),
        '    </button>',
        '</li>'
    ].join(newLine);
};

var storeListTemplate = function (stores, selectedStoreId, selectedStoreText) {
    if (stores && stores.length) {
        window.updateZip = false;

        return [
            zipPromptTemplate(),
            '<div class="store-list-container">',
            '<ul class="store-list">',
            _.map(stores, function (store) {
                return storeTemplate(store, selectedStoreId, selectedStoreText);
            }).join(newLine),
            '</ul>',
            '</div>',
            '<div class="store-list-pagination">',
            '</div>'
        ].join(newLine);
    } else {
        return zipPromptTemplate() + '<div class="no-results">' + String.format(Resources.NOSTOREFOUND, SitePreferences.STORE_LOOKUP_DISTANCE, SitePreferences.STORE_LOOKUP_UNIT, User.zip) + '</div>';
    }
};

var zipPromptTemplate = function () {
    return [
        `
        <form id="zip-prompt-form"><div id="preferred-store-panel" class="c-form-row form-row">
            <div class="c-form-row__form-field-container">
                <input type="text" id="user-zip" name="zipCode" class="c-form-row__input input-text postal ca-postal"
                    placeholder="${Resources.ENTER_ZIP}"
                    required
                    data-msg-required="${Resources.ENTER_ZIP_FORMAT}"
                />
            </div>
            <span class="store-search-button">${Resources.SEARCH}</span>
        </div></form>
        `
    ].join(newLine);
};

var storeinventory = {
    zipPrompt: function (callback) {
        
        dialog.open({
            html: zipPromptTemplate(),
            options: {
                dialogClass: 'find-in-store-modal',
                title: Resources.SELECT_STORE,
                width: 500,
                open: function () {
                    storeinventory.initCommon({searchCallback: callback});
                }
            }
        });
    },
    getStoresInventory: function (pid) {
        return TPromise.resolve($.ajax({
            url: util.appendParamsToUrl(Urls.storesInventory, {
                pid: pid,
                zipCode: User.zip
            }),
            dataType: 'json'
        }));
    },
    /**
     * @description open the dialog to select store
     * @param {Array} options.stores
     * @param {String} options.selectedStoreId
     * @param {String} options.selectedStoreText
     * @param {Function} options.continueCallback
     * @param {Function} options.selectStoreCallback
     **/
    selectStoreDialog: function (options) {
        var stores = options.stores,
            selectedStoreId = options.selectedStoreId,
            selectedStoreText = options.selectedStoreText;
        dialog.open({
            html: storeListTemplate(stores, selectedStoreId, selectedStoreText),
            options: {
                dialogClass: 'find-in-store-modal',
                title: Resources.SELECT_STORE + ' - ' + User.zip,
                open: function () {
                    storeinventory.initCommon(options);

                    $('.select-store-button').on('click', function (e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        var storeId = $(this).data('storeId');
                        // if the store is already selected, don't select again
                        if (storeId === selectedStoreId) { return; }
                        $('.store-list .store-tile.selected').removeClass('selected')
                            .find('.select-store-button').text(Resources.SELECT_STORE);
                        $(this).text(selectedStoreText)
                            .closest('.store-tile').addClass('selected');
                        selectedStoreId = storeId;
                        if (options.selectStoreCallback) {
                            options.selectStoreCallback(storeId);
                        }
                        dialog.close();
                    });
                }
            }
        });
    },
    initCommon: function (options) {
        $('.store-search-button').on('click', function (e) {
            if ($('#zip-prompt-form').valid()) {
                var zipCode = $('#user-zip').val();
                storeinventory.setUserZip(zipCode);
                if (typeof options.searchCallback === 'function') {
                    options.searchCallback(zipCode);
                }
            }
        });
        $('#user-zip').on('keypress', function (e) {
            if (e.which === 13) {
                // trigger the search button
                $('.search-store-button').trigger('click');
            }
        });
    },
    setUserZip: function (zip) {
        User.zip = zip;
        $.ajax({
            type: 'POST',
            url: Urls.setZipCode,
            data: {
                zipCode: zip
            }
        });
    },
    shippingLoad: function () {
        var $checkoutForm = $('.address');
        $checkoutForm.off('click');
        $checkoutForm.on('click', 'input[name$="_shippingAddress_isGift"]', function () {
            $(this).parent().siblings('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val());
        });
    }
};

module.exports = storeinventory;
